export const currencySymbols = {
    AUD: '$',
    BGN: 'лв',
    BRL: 'R$',
    CAD: '$',
    CHF: 'CHF',
    CNY: '¥',
    CZK: 'Kč',
    DKK: 'kr',
    EUR: '€',
    GBP: '£',
    HKD: 'HK$',
    HUF: 'Ft',
    IDR: 'Rp',
    ILS: '₪',
    INR: '₹',
    ISK: 'kr',
    JPY: '¥',
    KRW: '₩',
    MXN: '$',
    MYR: 'RM',
    NOK: 'kr',
    NZD: '$',
    PHP: '₱',
    PLN: 'zł',
    RON: 'lei',
    SEK: 'kr',
    SGD: 'S$',
    THB: '฿',
    TRY: '₺',
    ZAR: 'R',
  };